import axios from "axios";
import Config from "./Config";
import { toast } from "sonner";
const TOKEN = Config.getToken();

const { API_BASE_URL } = Config;
const headers = {
  Authorization: `Bearer ${TOKEN}`,
  "Content-Type": "application/json",
};


// =========================Get All OrderApi=========================
export const createOrder = async (data) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(`${API_BASE_URL}/create-order`, data, {
      headers,
    });
    if (response.data.status === true) {
      toast.success(response.data.message); // Toast success message
      return response.data; // Return response data
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    throw error;
  }
};


export const ApplyCoupon = async (data) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(`${API_BASE_URL}/apply-coupon`, data, {
      headers,
    });
    if (response.data.status === true) {
      return response.data;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    throw error;
  }
};

// =========================Get Order Status=========================
export const getOrderStatus = async (orderId) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.get(`${API_BASE_URL}/order/status/${orderId}`, {
      headers,
    });
    if (response.data.status === true) {
      return response.data;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error("Error fetching order status:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    throw error;
  }
};

// =========================Get All Orders=========================
export const getAllOrders = async () => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.get(`${API_BASE_URL}/orders`, {
      headers,
    });
    if (response.data.status === true) {
      return response.data;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error("Error fetching orders:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    throw error;
  }
};

// =========================Get Order Detail=========================
export const getOrderDetail = async (orderId) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.get(`${API_BASE_URL}/order/${orderId}`, {
      headers,
    });
    if (response.data.status === true) {
      return response.data;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error("Error fetching order detail:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    throw error;
  }
};

// =========================Cancel Order=========================
export const cancelOrder = async (orderId) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.put(`${API_BASE_URL}/order/cancel/${orderId}`, {}, {
      headers,
    });
    if (response.data.status === true) {
      toast.success(response.data.message);
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error canceling order:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to cancel order. Please try again.");
    throw error;
  }
};

// =========================Reorder=========================
export const reorderItems = async (orderId) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(`${API_BASE_URL}/reorder/${orderId}`, {}, {
      headers,
    });
    if (response.data.status === true) {
      toast.success(response.data.message);
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error reordering:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to reorder. Please try again.");
    throw error;
  }
};
